var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { iconsList } from "./icons-list";
import { StyledIcon } from "./styled";
var getSize = function (filename) {
    if (filename.endsWith("_s")) {
        return "small";
    }
    if (filename.endsWith("_l")) {
        return "large";
    }
    return "medium";
};
export var Icon = function (_a) {
    var name = _a.name, className = _a.className, size = _a.size, _b = _a.disabled, disabled = _b === void 0 ? false : _b, rest = __rest(_a, ["name", "className", "size", "disabled"]);
    var iconSymbol = iconsList[name];
    if (!iconSymbol) {
        return null;
    }
    var iconSize = size || getSize(name);
    return (React.createElement(StyledIcon, __assign({ viewBox: iconSymbol.viewBox }, rest, { size: iconSize, className: className, disabled: disabled }),
        React.createElement("use", { xlinkHref: "#" + iconSymbol.id })));
};
